/* FORGED — comportamiento propio. Un solo archivo, sin librerías (Lenis es opcional y aparte). */
(function () {
  if (window.__frgInit) return;
  window.__frgInit = true;
  // si llegamos a tiempo, la animación de entrada normal se encarga; si no, la red de seguridad del CSS ya enseñó el banner
  if (window.performance && performance.now() < 3000) document.documentElement.classList.add('frg-js-a-tiempo');

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var enEditor = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- altura de la cabecera ---------- */
  function medirCabecera() {
    var h = document.querySelector('.section-header');
    if (!h) return;
    var alto = Math.round(h.getBoundingClientRect().height);
    if (alto > 0) document.documentElement.style.setProperty('--frg-header-h', alto + 'px');
  }

  /* ---------- cabecera sólida al salir del héroe ---------- */
  var obsHeroe;
  function vigilarHeroe() {
    var body = document.body;
    if (!body.classList.contains('frg-home')) return;
    var heroe = document.querySelector('.frg-hero');
    if (!heroe) { body.classList.add('frg-header-solido'); return; }
    if (obsHeroe) obsHeroe.disconnect();
    obsHeroe = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        body.classList.toggle('frg-header-solido', !e.isIntersecting);
      });
    }, { rootMargin: '-' + 90 + 'px 0px 0px 0px', threshold: 0 });
    var centinela = heroe.querySelector('.frg-hero__centinela') || heroe;
    obsHeroe.observe(centinela);
  }

  /* ---------- palabras de los titulares ---------- */
  function partirPalabras(el) {
    if (el.dataset.frgWords) return;
    el.dataset.frgWords = '1';
    var partes = [];
    Array.prototype.slice.call(el.childNodes).forEach(function (nodo) {
      if (nodo.nodeType === 3) {
        nodo.textContent.split(/(\s+)/).forEach(function (t) {
          if (!t) return;
          if (/^\s+$/.test(t)) partes.push(document.createTextNode(' '));
          else partes.push(envolver(document.createTextNode(t)));
        });
      } else if (nodo.nodeType === 1 && nodo.tagName === 'BR') {
        partes.push(nodo.cloneNode());
      } else if (nodo.nodeType === 1) {
        partes.push(envolver(nodo.cloneNode(true)));
      }
    });
    el.innerHTML = '';
    partes.forEach(function (p) { el.appendChild(p); });
    el.classList.add('frg-words');
    var i = 0;
    el.querySelectorAll('.frg-word > span').forEach(function (s) { s.style.transitionDelay = (0.06 * i++) + 's'; });
  }
  function envolver(contenido) {
    var w = document.createElement('span'); w.className = 'frg-word';
    var s = document.createElement('span'); s.appendChild(contenido);
    w.appendChild(s);
    return w;
  }

  /* ---------- reveals ---------- */
  var obsReveal = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('frg-visible'); obsReveal.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }) : null;

  function initReveals(raiz) {
    raiz.querySelectorAll('[data-frg-words]').forEach(function (el) { if (!reduce) partirPalabras(el); });
    raiz.querySelectorAll('.frg-reveal, [data-frg-words], [data-frg-reveal], .frg-hero, .frg-look__linea').forEach(function (el) {
      if (reduce || !obsReveal || enEditor) { el.classList.add('frg-visible'); return; }
      if (el.dataset.frgObs) return; el.dataset.frgObs = '1';
      obsReveal.observe(el);
    });
  }

  /* ---------- tira en movimiento: duplica hasta cubrir 2x el ancho ---------- */
  function initTiras(raiz) {
    raiz.querySelectorAll('.frg-tira').forEach(function (tira) {
      if (tira.dataset.frgInit) return; tira.dataset.frgInit = '1';
      var pista = tira.querySelector('.frg-tira__pista');
      var grupo = pista && pista.querySelector('.frg-tira__grupo');
      if (!grupo) return;
      var originales = Array.prototype.slice.call(grupo.children);
      var ancho = grupo.getBoundingClientRect().width || 1;
      var copias = Math.max(1, Math.ceil((window.innerWidth * 1.2) / ancho));
      for (var i = 1; i < copias; i++) originales.forEach(function (n) { grupo.appendChild(n.cloneNode(true)); });
      // una segunda mitad idéntica para el bucle sin salto
      var clon = grupo.cloneNode(true); clon.setAttribute('aria-hidden', 'true');
      pista.appendChild(clon);
    });
  }

  /* ---------- paralaje (héroe, ventanas del lookbook, banda del cierre) ---------- */
  var capas = [];
  function initParalaje(raiz) {
    raiz.querySelectorAll('[data-frg-parallax]').forEach(function (el) {
      if (el.dataset.frgPar) return; el.dataset.frgPar = '1';
      capas.push(el);
    });
  }
  var pendiente = false;
  function pintarParalaje() {
    pendiente = false;
    var vh = window.innerHeight;
    capas = capas.filter(function (el) { return document.body.contains(el); });
    capas.forEach(function (el) {
      var padre = el.parentElement; if (!padre) return;
      var r = padre.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var vel = parseFloat(el.dataset.frgParallax) || 0;
      var centro = (r.top + r.height / 2) - vh / 2;
      var y = -centro * vel / 100;
      var margen = (el.getBoundingClientRect().height - r.height) / 2;
      if (margen > 0) y = Math.max(-margen, Math.min(margen, y));
      el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
    });
  }
  function pedirParalaje() { if (!pendiente && !reduce) { pendiente = true; requestAnimationFrame(pintarParalaje); } }

  /* ---------- lookbook: flechas con deslizamiento suave ---------- */
  function initLookbooks(raiz) {
    raiz.querySelectorAll('.frg-look').forEach(function (look) {
      if (look.dataset.frgInit) return; look.dataset.frgInit = '1';
      var pista = look.querySelector('.frg-look__pista');
      var items = pista ? pista.querySelectorAll('.frg-look__item') : [];
      var contador = look.querySelector('[data-frg-contador]');
      if (!pista || !items.length) return;
      function paso() { return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : pista.clientWidth; }
      function actual() { return Math.round(pista.scrollLeft / paso()); }
      function pintarContador() {
        if (!contador) return;
        var n = Math.min(items.length, actual() + 1);
        contador.textContent = String(n).padStart(2, '0') + ' / ' + String(items.length).padStart(2, '0');
      }
      function ir(dir) {
        var p = paso(), max = pista.scrollWidth - pista.clientWidth;
        var destino = Math.max(0, Math.min(max, (actual() + dir) * p));
        var inicio = pista.scrollLeft, t0 = null, dur = reduce ? 1 : 750;
        pista.classList.add('frg-sin-snap');
        function anim(t) {
          if (!t0) t0 = t;
          var k = Math.min(1, (t - t0) / dur);
          var e = k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
          pista.scrollLeft = inicio + (destino - inicio) * e;
          if (k < 1) requestAnimationFrame(anim); else { pista.classList.remove('frg-sin-snap'); pintarContador(); }
        }
        requestAnimationFrame(anim);
      }
      look.querySelectorAll('[data-frg-dir]').forEach(function (b) {
        b.addEventListener('click', function () { ir(parseInt(b.dataset.frgDir, 10)); });
      });
      pista.addEventListener('scroll', function () { pintarContador(); pedirParalaje(); }, { passive: true });
      pintarContador();
    });
  }

  /* ---------- máquina de escribir ---------- */
  function initMaquinas(raiz) {
    raiz.querySelectorAll('[data-frg-maquina]').forEach(function (el) {
      if (el.dataset.frgInit) return; el.dataset.frgInit = '1';
      var palabras = (el.dataset.frgMaquina || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
      var pausa = (parseFloat(el.dataset.frgPausa) || 2.2) * 1000;
      var txt = el.querySelector('.frg-maquina__txt');
      if (!txt || palabras.length < 2 || reduce) return;
      var i = 0, activo = false, corriendo = false;
      function escribir(p, cb) {
        var n = 0;
        (function paso() { txt.textContent = p.slice(0, ++n); if (n < p.length) setTimeout(paso, 70); else cb(); })();
      }
      function borrar(cb) {
        (function paso() { var t = txt.textContent; if (t.length) { txt.textContent = t.slice(0, -1); setTimeout(paso, 38); } else cb(); })();
      }
      function ciclo() {
        if (!activo) { corriendo = false; return; }
        corriendo = true;
        setTimeout(function () {
          borrar(function () { i = (i + 1) % palabras.length; escribir(palabras[i], ciclo); });
        }, pausa);
      }
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { activo = e.isIntersecting; if (activo && !corriendo) ciclo(); });
      }, { threshold: .3 }).observe(el);
    });
  }

  /* ---------- acordeón con foto viva ---------- */
  function initAcordeones(raiz) {
    raiz.querySelectorAll('[data-frg-acordeon]').forEach(function (ac) {
      if (ac.dataset.frgInit) return; ac.dataset.frgInit = '1';
      var fotos = ac.querySelectorAll('[data-frg-foto]');
      var unico = ac.hasAttribute('data-frg-unico');
      ac.querySelectorAll('details').forEach(function (d, idx) {
        d.addEventListener('toggle', function () {
          if (d.open) {
            if (unico) ac.querySelectorAll('details').forEach(function (o) { if (o !== d) o.open = false; });
            var i = d.dataset.frgIndice || String(idx);
            fotos.forEach(function (f) { f.classList.toggle('frg-activa', f.dataset.frgFoto === i); });
          }
        });
      });
    });
  }

  /* ---------- selector de variantes (portada y página de producto) ---------- */
  function formatear(cents) {
    var formato = document.body.getAttribute('data-frg-moneda') || '${{amount}}';
    function conSeparadores(n, dec, miles, decimal) {
      var partes = (n / 100).toFixed(dec).split('.');
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles);
      return partes.length > 1 ? partes[0] + decimal + partes[1] : partes[0];
    }
    var m = formato.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return (cents / 100).toFixed(2);
    var valor;
    switch (m[1]) {
      case 'amount_no_decimals': valor = conSeparadores(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': valor = conSeparadores(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': valor = conSeparadores(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': valor = conSeparadores(cents, 2, "'", '.'); break;
      default: valor = conSeparadores(cents, 2, ',', '.');
    }
    return formato.replace(m[0], valor);
  }
  function initComprar(raiz) {
    raiz.querySelectorAll('[data-frg-comprar]').forEach(function (caja) {
      if (caja.dataset.frgInit) return; caja.dataset.frgInit = '1';
      var json = caja.querySelector('script[data-frg-variantes]');
      if (!json) return;
      var variantes = JSON.parse(json.textContent);
      var inputId = caja.querySelector('input[name="id"]');
      var precio = caja.querySelectorAll('[data-frg-precio]');
      var boton = caja.querySelector('[data-frg-boton]');
      var botonTxt = boton && boton.querySelector('[data-frg-boton-txt]');
      var textoAdd = boton ? boton.dataset.textoAdd : '';
      var textoAgotado = boton ? boton.dataset.textoAgotado : '';
      var grupos = caja.querySelectorAll('[data-frg-opcion]');
      var imgPrincipal = document.querySelector(caja.dataset.frgImagen || '__nada__');

      function seleccion() {
        return Array.prototype.map.call(grupos, function (g) {
          var r = g.querySelector('input:checked'); return r ? r.value : null;
        });
      }
      function buscar(ops) {
        return variantes.find(function (v) { return v.options.every(function (o, i) { return ops[i] === null || o === ops[i]; }); });
      }
      function actualizar(desdeUsuario) {
        var ops = seleccion();
        var v = buscar(ops);
        grupos.forEach(function (g, gi) {
          var etiqueta = g.querySelector('[data-frg-valor]');
          if (etiqueta && ops[gi] !== null) etiqueta.textContent = ops[gi];
        });
        // tallas agotadas para la combinación actual
        grupos.forEach(function (g, gi) {
          g.querySelectorAll('.frg-talla').forEach(function (lab) {
            var val = lab.querySelector('input').value;
            var prueba = ops.slice(); prueba[gi] = val;
            var cand = buscar(prueba);
            lab.classList.toggle('frg-talla--agotada', !cand || !cand.available);
          });
        });
        if (!v) return;
        if (inputId) { inputId.value = v.id; inputId.dispatchEvent(new Event('change', { bubbles: true })); }
        precio.forEach(function (p) {
          p.innerHTML = formatear(v.price) + (v.compare_at_price > v.price ? ' <s>' + formatear(v.compare_at_price) + '</s>' : '');
        });
        if (boton) {
          if (v.available) { boton.removeAttribute('disabled'); boton.removeAttribute('aria-disabled'); if (botonTxt) botonTxt.textContent = textoAdd; }
          else { boton.setAttribute('disabled', 'disabled'); if (botonTxt) botonTxt.textContent = textoAgotado; }
        }
        if (desdeUsuario && v.featured_image && imgPrincipal) {
          var hermana = imgPrincipal.parentElement && imgPrincipal.parentElement.querySelector('.frg-img-2');
          // Si la foto de la variante ya se está enseñando (p. ej. todas las tallas comparten foto), no se toca nada:
          // así se conserva el giro delante/espalda al pasar el ratón.
          var nombreFoto = function (s) { return (s || '').split('?')[0].split('/').pop(); };
          var fotoNueva = nombreFoto(v.featured_image.src);
          if (fotoNueva === nombreFoto(imgPrincipal.getAttribute('src')) || (hermana && fotoNueva === nombreFoto(hermana.getAttribute('src')))) {
            fotoNueva = null;
          }
        }
        if (desdeUsuario && v.featured_image && imgPrincipal && fotoNueva) {
          if (hermana) hermana.remove();
          imgPrincipal.src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1600';
          imgPrincipal.removeAttribute('srcset');
        }
        if (caja.dataset.frgUrl === 'true' && window.history && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
        }
        document.querySelectorAll('[data-frg-sticky-precio]').forEach(function (p) { p.textContent = formatear(v.price); });
      }
      caja.addEventListener('change', function (e) { if (e.target.matches('[data-frg-opcion] input')) actualizar(true); });
      actualizar(false);
    });
  }

  /* ---------- guía de tallas ---------- */
  function initDialogos(raiz) {
    raiz.querySelectorAll('[data-frg-abrir]').forEach(function (b) {
      if (b.dataset.frgInit) return; b.dataset.frgInit = '1';
      b.addEventListener('click', function () {
        var d = document.getElementById(b.dataset.frgAbrir);
        if (d && d.showModal) d.showModal();
      });
    });
    raiz.querySelectorAll('dialog.frg-dialogo').forEach(function (d) {
      if (d.dataset.frgInit) return; d.dataset.frgInit = '1';
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
      var c = d.querySelector('[data-frg-cerrar]'); if (c) c.addEventListener('click', function () { d.close(); });
    });
  }

  /* ---------- barra de compra fija en móvil ---------- */
  function initStickyMovil(raiz) {
    var barra = raiz.querySelector('.frg-sticky-movil');
    var ancla = raiz.querySelector('[data-frg-boton]');
    if (!barra || !ancla || barra.dataset.frgInit) return; barra.dataset.frgInit = '1';
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { barra.classList.toggle('frg-visible-barra', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }).observe(ancla);
    var b = barra.querySelector('button');
    if (b) b.addEventListener('click', function () { ancla.click(); });
  }

  /* ---------- scroll suave ---------- */
  function initLenis() {
    if (reduce || enEditor || !window.Lenis || window.__frgLenis) return;
    var lenis = new window.Lenis({ lerp: 0.09, smoothWheel: true });
    window.__frgLenis = lenis;
    document.documentElement.classList.add('frg-lenis');
    function raf(t) { lenis.raf(t); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#"]');
      if (!a) return;
      var url = new URL(a.href, window.location.href);
      if (url.pathname !== window.location.pathname || !url.hash) return;
      var destino = document.querySelector(url.hash);
      if (destino) { e.preventDefault(); lenis.scrollTo(destino, { offset: -70 }); }
    });
  }

  function iniciar(raiz) {
    raiz = raiz || document;
    medirCabecera();
    initReveals(raiz); initTiras(raiz); initParalaje(raiz); initLookbooks(raiz);
    initMaquinas(raiz); initAcordeones(raiz); initComprar(raiz); initDialogos(raiz); initStickyMovil(raiz);
    vigilarHeroe(); pedirParalaje();
  }

  document.addEventListener('DOMContentLoaded', function () { iniciar(document); initLenis(); });
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
  window.addEventListener('scroll', pedirParalaje, { passive: true });
  window.addEventListener('resize', function () { medirCabecera(); pedirParalaje(); });
  window.addEventListener('load', function () { medirCabecera(); pedirParalaje(); });
})();
